export var CameraModus;
(function (CameraModus) {
    CameraModus["Off"] = "off";
    CameraModus["Small"] = "small";
    CameraModus["Large"] = "large";
})(CameraModus || (CameraModus = {}));
